const languages = [
  {
    key: "en",
    value: "en",
    label: "English",
    description: "",
  },
  {
    key: "ab",
    value: "ab",
    label: "Abkhaz",
    description: "аҧсуа",
  },
  {
    key: "aa",
    value: "aa",
    label: "Afar",
    description: "Afaraf",
  },
  {
    key: "af",
    value: "af",
    label: "Afrikaans",
    description: "Afrikaans",
  },
  {
    key: "ak",
    value: "ak",
    label: "Akan",
    description: "Akan",
  },
  {
    key: "sq",
    value: "sq",
    label: "Albanian",
    description: "Shqip",
  },
  {
    key: "am",
    value: "am",
    label: "Amharic",
    description: "አማርኛ",
  },
  {
    key: "ar",
    value: "ar",
    label: "Arabic",
    description: "العربية",
  },
  {
    key: "an",
    value: "an",
    label: "Aragonese",
    description: "Aragonés",
  },
  {
    key: "hy",
    value: "hy",
    label: "Armenian",
    description: "Հայերեն",
  },
  {
    key: "as",
    value: "as",
    label: "Assamese",
    description: "অসমীয়া",
  },
  {
    key: "av",
    value: "av",
    label: "Avaric",
    description: "авар мацӀ, магӀарул мацӀ",
  },
  {
    key: "ae",
    value: "ae",
    label: "Avestan",
    description: "avesta",
  },
  {
    key: "ay",
    value: "ay",
    label: "Aymara",
    description: "aymar aru",
  },
  {
    key: "az",
    value: "az",
    label: "Azerbaijani",
    description: "azərbaycan dili",
  },
  {
    key: "bm",
    value: "bm",
    label: "Bambara",
    description: "bamanankan",
  },
  {
    key: "ba",
    value: "ba",
    label: "Bashkir",
    description: "башҡорт теле",
  },
  {
    key: "eu",
    value: "eu",
    label: "Basque",
    description: "euskara, euskera",
  },
  {
    key: "be",
    value: "be",
    label: "Belarusian",
    description: "Беларуская",
  },
  {
    key: "bn",
    value: "bn",
    label: "Bengali",
    description: "বাংলা",
  },
  {
    key: "bh",
    value: "bh",
    label: "Bihari",
    description: "भोजपुरी",
  },
  {
    key: "bi",
    value: "bi",
    label: "Bislama",
    description: "Bislama",
  },
  {
    key: "bs",
    value: "bs",
    label: "Bosnian",
    description: "bosanski jezik",
  },
  {
    key: "br",
    value: "br",
    label: "Breton",
    description: "brezhoneg",
  },
  {
    key: "bg",
    value: "bg",
    label: "Bulgarian",
    description: "български език",
  },
  {
    key: "my",
    value: "my",
    label: "Burmese",
    description: "ဗမာစာ",
  },
  {
    key: "ca",
    value: "ca",
    label: "Catalan; Valencian",
    description: "Català",
  },
  {
    key: "ch",
    value: "ch",
    label: "Chamorro",
    description: "Chamoru",
  },
  {
    key: "ce",
    value: "ce",
    label: "Chechen",
    description: "нохчийн мотт",
  },
  {
    key: "ny",
    value: "ny",
    label: "Chichewa; Chewa; Nyanja",
    description: "chiCheŵa, chinyanja",
  },
  // CHINESE: ISO 639
  // NOTE: Required for Case Tracker backward-compatibility.
  {
    key: "zh",
    value: "zh",
    label: "Chinese",
    description: "中文 (Zhōngwén), 汉语, 漢語",
  },
  // MANDARIN CHINESE: ISO 639-3
  {
    key: "cmn",
    value: "cmn",
    label: "Mandarin Chinese",
    description: "普通话",
  },
  // CANTONESE (YUE) CHINESE: ISO 639-3
  {
    key: "yue",
    value: "yue",
    label: "Cantonese Chinese",
    description: "廣州話, 廣府話, 廣東話, 粵語",
  },
  {
    key: "cv",
    value: "cv",
    label: "Chuvash",
    description: "чӑваш чӗлхи",
  },
  {
    key: "kw",
    value: "kw",
    label: "Cornish",
    description: "Kernewek",
  },
  {
    key: "co",
    value: "co",
    label: "Corsican",
    description: "corsu, lingua corsa",
  },
  {
    key: "cr",
    value: "cr",
    label: "Cree",
    description: "ᓀᐦᐃᔭᐍᐏᐣ",
  },
  {
    key: "hr",
    value: "hr",
    label: "Croatian",
    description: "hrvatski",
  },
  {
    key: "cs",
    value: "cs",
    label: "Czech",
    description: "česky, čeština",
  },
  {
    key: "da",
    value: "da",
    label: "Danish",
    description: "dansk",
  },
  {
    key: "dv",
    value: "dv",
    label: "Divehi; Dhivehi; Maldivian;",
    description: "ދިވެހި",
  },
  {
    key: "nl",
    value: "nl",
    label: "Dutch",
    description: "Nederlands, Vlaams",
  },
  {
    key: "eo",
    value: "eo",
    label: "Esperanto",
    description: "Esperanto",
  },
  {
    key: "et",
    value: "et",
    label: "Estonian",
    description: "eesti, eesti keel",
  },
  {
    key: "ee",
    value: "ee",
    label: "Ewe",
    description: "Eʋegbe",
  },
  {
    key: "fo",
    value: "fo",
    label: "Faroese",
    description: "føroyskt",
  },
  {
    key: "fj",
    value: "fj",
    label: "Fijian",
    description: "vosa Vakaviti",
  },
  {
    key: "fi",
    value: "fi",
    label: "Finnish",
    description: "suomi, suomen kieli",
  },
  {
    key: "fr",
    value: "fr",
    label: "French",
    description: "français, langue française",
  },
  {
    key: "ff",
    value: "ff",
    label: "Fula; Fulah; Pulaar; Pular",
    description: "Fulfulde, Pulaar, Pular",
  },
  {
    key: "gl",
    value: "gl",
    label: "Galician",
    description: "Galego",
  },
  {
    key: "ka",
    value: "ka",
    label: "Georgian",
    description: "ქართული",
  },
  {
    key: "de",
    value: "de",
    label: "German",
    description: "Deutsch",
  },
  {
    key: "el",
    value: "el",
    label: "Greek, Modern",
    description: "Ελληνικά",
  },
  {
    key: "gn",
    value: "gn",
    label: "Guaraní",
    description: "Avañeẽ",
  },
  {
    key: "gu",
    value: "gu",
    label: "Gujarati",
    description: "ગુજરાતી",
  },
  {
    key: "ht",
    value: "ht",
    label: "Haitian; Haitian Creole",
    description: "Kreyòl ayisyen",
  },
  {
    key: "ha",
    value: "ha",
    label: "Hausa",
    description: "Hausa, هَوُسَ",
  },
  {
    key: "he",
    value: "he",
    label: "Hebrew (modern)",
    description: "עברית",
  },
  {
    key: "hz",
    value: "hz",
    label: "Herero",
    description: "Otjiherero",
  },
  {
    key: "hi",
    value: "hi",
    label: "Hindi",
    description: "हिन्दी, हिंदी",
  },
  {
    key: "ho",
    value: "ho",
    label: "Hiri Motu",
    description: "Hiri Motu",
  },
  {
    key: "hu",
    value: "hu",
    label: "Hungarian",
    description: "Magyar",
  },
  {
    key: "ia",
    value: "ia",
    label: "Interlingua",
    description: "Interlingua",
  },
  {
    key: "id",
    value: "id",
    label: "Indonesian",
    description: "Bahasa Indonesia",
  },
  {
    key: "ie",
    value: "ie",
    label: "Interlingue",
    description: "Originally called Occidental; then Interlingue after WWII",
  },
  {
    key: "ga",
    value: "ga",
    label: "Irish",
    description: "Gaeilge",
  },
  {
    key: "ig",
    value: "ig",
    label: "Igbo",
    description: "Asụsụ Igbo",
  },
  {
    key: "ik",
    value: "ik",
    label: "Inupiaq",
    description: "Iñupiaq, Iñupiatun",
  },
  {
    key: "io",
    value: "io",
    label: "Ido",
    description: "Ido",
  },
  {
    key: "is",
    value: "is",
    label: "Icelandic",
    description: "Íslenska",
  },
  {
    key: "it",
    value: "it",
    label: "Italian",
    description: "Italiano",
  },
  {
    key: "iu",
    value: "iu",
    label: "Inuktitut",
    description: "ᐃᓄᒃᑎᑐᑦ",
  },
  {
    key: "ja",
    value: "ja",
    label: "Japanese",
    description: "日本語, にほんご",
  },
  {
    key: "jv",
    value: "jv",
    label: "Javanese",
    description: "basa Jawa",
  },
  {
    key: "kl",
    value: "kl",
    label: "Kalaallisut, Greenlandic",
    description: "kalaallisut, kalaallit oqaasii",
  },
  {
    key: "kn",
    value: "kn",
    label: "Kannada",
    description: "ಕನ್ನಡ",
  },
  {
    key: "kr",
    value: "kr",
    label: "Kanuri",
    description: "Kanuri",
  },
  {
    key: "ks",
    value: "ks",
    label: "Kashmiri",
    description: "कश्मीरी, كشميري‎",
  },
  {
    key: "kk",
    value: "kk",
    label: "Kazakh",
    description: "Қазақ тілі",
  },
  {
    key: "km",
    value: "km",
    label: "Khmer",
    description: "ភាសាខ្មែរ",
  },
  {
    key: "ki",
    value: "ki",
    label: "Kikuyu, Gikuyu",
    description: "Gĩkũyũ",
  },
  {
    key: "rw",
    value: "rw",
    label: "Kinyarwanda",
    description: "Ikinyarwanda",
  },
  {
    key: "ky",
    value: "ky",
    label: "Kirghiz, Kyrgyz",
    description: "кыргыз тили",
  },
  {
    key: "kv",
    value: "kv",
    label: "Komi",
    description: "коми кыв",
  },
  {
    key: "kg",
    value: "kg",
    label: "Kongo",
    description: "KiKongo",
  },
  {
    key: "ko",
    value: "ko",
    label: "Korean",
    description: "한국어",
  },
  {
    key: "ku",
    value: "ku",
    label: "Kurdish",
    description: "Kurdî, كوردی‎",
  },
  {
    key: "kj",
    value: "kj",
    label: "Kwanyama, Kuanyama",
    description: "Kuanyama",
  },
  {
    key: "la",
    value: "la",
    label: "Latin",
    description: "latine, lingua latina",
  },
  {
    key: "lb",
    value: "lb",
    label: "Luxembourgish, Letzeburgesch",
    description: "Lëtzebuergesch",
  },
  {
    key: "lg",
    value: "lg",
    label: "Luganda",
    description: "Luganda",
  },
  {
    key: "li",
    value: "li",
    label: "Limburgish, Limburgan, Limburger",
    description: "Limburgs",
  },
  {
    key: "ln",
    value: "ln",
    label: "Lingala",
    description: "Lingála",
  },
  {
    key: "lo",
    value: "lo",
    label: "Lao",
    description: "ພາສາລາວ",
  },
  {
    key: "lt",
    value: "lt",
    label: "Lithuanian",
    description: "lietuvių kalba",
  },
  {
    key: "lu",
    value: "lu",
    label: "Luba-Katanga",
    description: "",
  },
  {
    key: "lv",
    value: "lv",
    label: "Latvian",
    description: "latviešu valoda",
  },
  {
    key: "gv",
    value: "gv",
    label: "Manx",
    description: "Gaelg, Gailck",
  },
  {
    key: "mk",
    value: "mk",
    label: "Macedonian",
    description: "македонски јазик",
  },
  {
    key: "mg",
    value: "mg",
    label: "Malagasy",
    description: "Malagasy fiteny",
  },
  {
    key: "ms",
    value: "ms",
    label: "Malay",
    description: "bahasa Melayu, بهاس ملايو‎",
  },
  {
    key: "ml",
    value: "ml",
    label: "Malayalam",
    description: "മലയാളം",
  },
  {
    key: "mt",
    value: "mt",
    label: "Maltese",
    description: "Malti",
  },
  {
    key: "mi",
    value: "mi",
    label: "Māori",
    description: "te reo Māori",
  },
  {
    key: "mr",
    value: "mr",
    label: "Marathi (Marāṭhī)",
    description: "मराठी",
  },
  {
    key: "mh",
    value: "mh",
    label: "Marshallese",
    description: "Kajin M̧ajeļ",
  },
  {
    key: "mn",
    value: "mn",
    label: "Mongolian",
    description: "монгол",
  },
  {
    key: "na",
    value: "na",
    label: "Nauru",
    description: "Ekakairũ Naoero",
  },
  {
    key: "nv",
    value: "nv",
    label: "Navajo, Navaho",
    description: "Diné bizaad, Dinékʼehǰí",
  },
  {
    key: "nb",
    value: "nb",
    label: "Norwegian Bokmål",
    description: "Norsk bokmål",
  },
  {
    key: "nd",
    value: "nd",
    label: "North Ndebele",
    description: "isiNdebele",
  },
  {
    key: "ne",
    value: "ne",
    label: "Nepali",
    description: "नेपाली",
  },
  {
    key: "ng",
    value: "ng",
    label: "Ndonga",
    description: "Owambo",
  },
  {
    key: "nn",
    value: "nn",
    label: "Norwegian Nynorsk",
    description: "Norsk nynorsk",
  },
  {
    key: "no",
    value: "no",
    label: "Norwegian",
    description: "Norsk",
  },
  {
    key: "ii",
    value: "ii",
    label: "Nuosu",
    description: "ꆈꌠ꒿ Nuosuhxop",
  },
  {
    key: "nr",
    value: "nr",
    label: "South Ndebele",
    description: "isiNdebele",
  },
  {
    key: "oc",
    value: "oc",
    label: "Occitan",
    description: "Occitan",
  },
  {
    key: "oj",
    value: "oj",
    label: "Ojibwe, Ojibwa",
    description: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
  },
  {
    key: "cu",
    value: "cu",
    label:
      "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    description: "ѩзыкъ словѣньскъ",
  },
  {
    key: "om",
    value: "om",
    label: "Oromo",
    description: "Afaan Oromoo",
  },
  {
    key: "or",
    value: "or",
    label: "Oriya",
    description: "ଓଡ଼ିଆ",
  },
  {
    key: "os",
    value: "os",
    label: "Ossetian, Ossetic",
    description: "ирон æвзаг",
  },
  {
    key: "pa",
    value: "pa",
    label: "Panjabi, Punjabi",
    description: "ਪੰਜਾਬੀ, پنجابی‎",
  },
  {
    key: "pi",
    value: "pi",
    label: "Pāli",
    description: "पाऴि",
  },
  {
    key: "fa",
    value: "fa",
    label: "Persian",
    description: "فارسی",
  },
  {
    key: "pl",
    value: "pl",
    label: "Polish",
    description: "polski",
  },
  {
    key: "ps",
    value: "ps",
    label: "Pashto, Pushto",
    description: "پښتو",
  },
  {
    key: "pt",
    value: "pt",
    label: "Portuguese",
    description: "Português",
  },
  {
    key: "qu",
    value: "qu",
    label: "Quechua",
    description: "Runa Simi, Kichwa",
  },
  {
    key: "rm",
    value: "rm",
    label: "Romansh",
    description: "rumantsch grischun",
  },
  {
    key: "rn",
    value: "rn",
    label: "Kirundi",
    description: "kiRundi",
  },
  {
    key: "ro",
    value: "ro",
    label: "Romanian, Moldavian, Moldovan",
    description: "română",
  },
  {
    key: "ru",
    value: "ru",
    label: "Russian",
    description: "русский язык",
  },
  {
    key: "sa",
    value: "sa",
    label: "Sanskrit (Saṁskṛta)",
    description: "संस्कृतम्",
  },
  {
    key: "sc",
    value: "sc",
    label: "Sardinian",
    description: "sardu",
  },
  {
    key: "sd",
    value: "sd",
    label: "Sindhi",
    description: "सिन्धी, سنڌي، سندھی‎",
  },
  {
    key: "se",
    value: "se",
    label: "Northern Sami",
    description: "Davvisámegiella",
  },
  {
    key: "sm",
    value: "sm",
    label: "Samoan",
    description: "gagana faa Samoa",
  },
  {
    key: "sg",
    value: "sg",
    label: "Sango",
    description: "yângâ tî sängö",
  },
  {
    key: "sr",
    value: "sr",
    label: "Serbian",
    description: "српски језик",
  },
  {
    key: "gd",
    value: "gd",
    label: "Scottish Gaelic; Gaelic",
    description: "Gàidhlig",
  },
  {
    key: "sn",
    value: "sn",
    label: "Shona",
    description: "chiShona",
  },
  {
    key: "si",
    value: "si",
    label: "Sinhala, Sinhalese",
    description: "සිංහල",
  },
  {
    key: "sk",
    value: "sk",
    label: "Slovak",
    description: "slovenčina",
  },
  {
    key: "sl",
    value: "sl",
    label: "Slovene",
    description: "slovenščina",
  },
  {
    key: "so",
    value: "so",
    label: "Somali",
    description: "Soomaaliga, af Soomaali",
  },
  {
    key: "st",
    value: "st",
    label: "Southern Sotho",
    description: "Sesotho",
  },
  {
    key: "es",
    value: "es",
    label: "Spanish; Castilian",
    description: "español, castellano",
  },
  {
    key: "su",
    value: "su",
    label: "Sundanese",
    description: "Basa Sunda",
  },
  {
    key: "sw",
    value: "sw",
    label: "Swahili",
    description: "Kiswahili",
  },
  {
    key: "ss",
    value: "ss",
    label: "Swati",
    description: "SiSwati",
  },
  {
    key: "sv",
    value: "sv",
    label: "Swedish",
    description: "svenska",
  },
  {
    key: "ta",
    value: "ta",
    label: "Tamil",
    description: "தமிழ்",
  },
  {
    key: "te",
    value: "te",
    label: "Telugu",
    description: "తెలుగు",
  },
  {
    key: "tg",
    value: "tg",
    label: "Tajik",
    description: "тоҷикӣ, toğikī, تاجیکی‎",
  },
  {
    key: "th",
    value: "th",
    label: "Thai",
    description: "ไทย",
  },
  {
    key: "ti",
    value: "ti",
    label: "Tigrinya",
    description: "ትግርኛ",
  },
  {
    key: "bo",
    value: "bo",
    label: "Tibetan Standard, Tibetan, Central",
    description: "བོད་ཡིག",
  },
  {
    key: "tk",
    value: "tk",
    label: "Turkmen",
    description: "Türkmen, Түркмен",
  },
  {
    key: "tl",
    value: "tl",
    label: "Tagalog",
    description: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
  },
  {
    key: "tn",
    value: "tn",
    label: "Tswana",
    description: "Setswana",
  },
  {
    key: "to",
    value: "to",
    label: "Tonga (Tonga Islands)",
    description: "faka Tonga",
  },
  {
    key: "tr",
    value: "tr",
    label: "Turkish",
    description: "Türkçe",
  },
  {
    key: "ts",
    value: "ts",
    label: "Tsonga",
    description: "Xitsonga",
  },
  {
    key: "tt",
    value: "tt",
    label: "Tatar",
    description: "татарча, tatarça, تاتارچا‎",
  },
  {
    key: "tw",
    value: "tw",
    label: "Twi",
    description: "Twi",
  },
  {
    key: "ty",
    value: "ty",
    label: "Tahitian",
    description: "Reo Tahiti",
  },
  {
    key: "ug",
    value: "ug",
    label: "Uighur, Uyghur",
    description: "Uyƣurqə, ئۇيغۇرچە‎",
  },
  {
    key: "uk",
    value: "uk",
    label: "Ukrainian",
    description: "українська",
  },
  {
    key: "ur",
    value: "ur",
    label: "Urdu",
    description: "اردو",
  },
  {
    key: "uz",
    value: "uz",
    label: "Uzbek",
    description: "zbek, Ўзбек, أۇزبېك‎",
  },
  {
    key: "ve",
    value: "ve",
    label: "Venda",
    description: "Tshivenḓa",
  },
  {
    key: "vi",
    value: "vi",
    label: "Vietnamese",
    description: "Tiếng Việt",
  },
  {
    key: "vo",
    value: "vo",
    label: "Volapük",
    description: "Volapük",
  },
  {
    key: "wa",
    value: "wa",
    label: "Walloon",
    description: "Walon",
  },
  {
    key: "cy",
    value: "cy",
    label: "Welsh",
    description: "Cymraeg",
  },
  {
    key: "wo",
    value: "wo",
    label: "Wolof",
    description: "Wollof",
  },
  {
    key: "fy",
    value: "fy",
    label: "Western Frisian",
    description: "Frysk",
  },
  {
    key: "xh",
    value: "xh",
    label: "Xhosa",
    description: "isiXhosa",
  },
  {
    key: "yi",
    value: "yi",
    label: "Yiddish",
    description: "ייִדיש",
  },
  {
    key: "yo",
    value: "yo",
    label: "Yoruba",
    description: "Yorùbá",
  },
  {
    key: "za",
    value: "za",
    label: "Zhuang, Chuang",
    description: "Saɯ cueŋƅ, Saw cuengh",
  },
];

export default languages;
